module.exports = __webpack_public_path__ + "static/media/elysia-bg.356b29b5.png";